import { Pagination as UDSPagination } from '@telus-uds/components-web'
import type { Language } from '@/siteBuilder/locale'

type PaginationProps = {
  numOfArticles: number
  currentPage: number
  displayCount: number
  lang: Language
  setCurrentPage: (currentPage: number) => void
}

type GetPagesArray = (numOfArticles: number, displayCount: number) => number[]

export const getPagesArray: GetPagesArray = (numOfArticles, displayCount) => {
  const addValue = (numOfArticles / displayCount) % 1 >= 0.5 || (numOfArticles / displayCount) % 1 === 0 ? 0 : 1 // whether to add an extra page or not depending on decimal
  const pages = [...Array(Math.round(numOfArticles / displayCount) + addValue).keys()]
  return pages
}

const Pagination = ({ numOfArticles, currentPage, setCurrentPage, displayCount, lang }: PaginationProps) => {
  const pages = getPagesArray(numOfArticles, displayCount)
  return (
    <UDSPagination copy={lang} sideButtonVariant={{ compact: true }}>
      {pages.map((item, i) => {
        return (
          <UDSPagination.PageButton
            key={i}
            href={`#${item}`}
            isActive={item === currentPage}
            onPress={() => setCurrentPage(item)}
          />
        )
      })}
    </UDSPagination>
  )
}

export default Pagination
